import mixpanel from "mixpanel-browser";
import { OnboardingIntroExperimentVariant } from "../../../../constants/onboarding-intro-experiment-variant.enum";
import {
  ONBOARDING_INTRO_EXPERIMENT_PROPERTY,
  PENDING_ONBOARDING_INTRO_ASSIGNMENT_STORAGE_KEY,
} from "./onboarding-intro-experiment.const";

export function assignOnboardingIntroExperiment(variant: string): void {
  const isTrackableVariant =
    variant === OnboardingIntroExperimentVariant.CONTROL || variant === OnboardingIntroExperimentVariant.INTRO_SCREEN;
  if (!isTrackableVariant) {
    return;
  }

  if (mixpanel.has_opted_out_tracking()) {
    localStorage.setItem(PENDING_ONBOARDING_INTRO_ASSIGNMENT_STORAGE_KEY, variant);
    return;
  }

  mixpanel.people.set_once({
    [ONBOARDING_INTRO_EXPERIMENT_PROPERTY]: variant,
  });
  localStorage.removeItem(PENDING_ONBOARDING_INTRO_ASSIGNMENT_STORAGE_KEY);
}

export function flushPendingOnboardingIntroAssignment(): void {
  const pendingVariant = localStorage.getItem(PENDING_ONBOARDING_INTRO_ASSIGNMENT_STORAGE_KEY);
  if (!pendingVariant) {
    return;
  }

  assignOnboardingIntroExperiment(pendingVariant);
}
